import { createContext } from "react";

/**
 * The negotiation an archived proposal was negotiated in, as the reader may read it.
 *
 * The archive is read-only, so its fields carry the read-only history popover the live pages give a
 * reader who may not edit — the history of a proposal lives in each field's own popover since the
 * whole-proposal History drawer was removed (#5567). The page resolves the negotiation once; each tab
 * reads it from here rather than having it threaded through.
 *
 * Undefined until the negotiation loads, and for a proposal archived before negotiations were
 * recorded, which has no history to read: the buttons then draw nothing.
 */
export type ArchivedProposalNegotiation = {
  negotiationId: string;
  viewerScope: string;
};

export const ArchivedProposalNegotiationContext = createContext<ArchivedProposalNegotiation | undefined>(undefined);
